document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('.site-nav');
  if (nav) window.addEventListener('scroll', function () { nav.classList.toggle('scrolled', window.scrollY > 10); });
  var burger = document.querySelector('.nav-burger'), mob = document.querySelector('.mobile-nav');
  if (burger && mob) burger.addEventListener('click', function () {
    mob.classList.toggle('open');
    document.body.style.overflow = mob.classList.contains('open') ? 'hidden' : '';
  });
  (function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var dotWrap = hero.querySelector('.hero-nav');

    // Randomise the order of the artist spotlight slides (brand slide stays first)
    var artistSlides = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide--artist'));
    if (artistSlides.length > 1) {
      for (var i = artistSlides.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = artistSlides[i]; artistSlides[i] = artistSlides[j]; artistSlides[j] = t;
      }
      var parent = artistSlides[0].parentNode;
      artistSlides.forEach(function (s) { parent.insertBefore(s, dotWrap || null); });
    }

    var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide'));
    if (!slides.length) return;
    slides.forEach(function (s, i) { s.classList.toggle('active', i === 0); });
    var cur = 0, dots = [], timer = null;

    if (dotWrap) {
      dotWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'hero-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dotWrap.appendChild(d); dots.push(d);
      });
    }

    function go(n) {
      slides[cur].classList.remove('active'); if (dots[cur]) dots[cur].classList.remove('active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active'); if (dots[cur]) dots[cur].classList.add('active');
    }
    function restart() { if (timer) clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { go(cur + 1); }, 6000); }

    var prev = hero.querySelector('.hero-arrow--prev'), next = hero.querySelector('.hero-arrow--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); restart(); });

    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? cur + 1 : cur - 1); restart(); }
      x0 = null;
    }, { passive: true });

    hero.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
    restart();
  })();
});

document.addEventListener('DOMContentLoaded', function () {
  // Advisory tabs
  document.querySelectorAll('.advisory-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.advisory-tab').forEach(function (t){t.classList.remove('active');});
      document.querySelectorAll('.advisory-panel').forEach(function (p){p.classList.remove('active');});
      tab.classList.add('active');
      var el = document.getElementById(tab.dataset.panel);
      if (el) el.classList.add('active');
    });
  });
  // Newsletter (demo feedback)
  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = form.querySelector('button'); if(!b) return;
      b.textContent = 'Subscribed \u2713'; b.style.background = '#2d7a3a';
      setTimeout(function(){ b.textContent='Subscribe'; b.style.background=''; }, 3000);
    });
  });
  // Smooth scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
  });
});
